import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {UrlQueryService} from '../../../common/url-query/url-query.service';

@Injectable({
  providedIn: 'root'
})
export class SnmpDestinationApiService {

  constructor(private http: HttpClient) {}

  readonly snmpDestinationUrl: string = 'externals/snmp/target';

  public getSnmpDestination(params: any = {}): Observable<any> {
    params = UrlQueryService.restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(this.snmpDestinationUrl, params);

    return this.http.get(url);
  }

  public addSnmpDestination(attr: object): Promise<any>{
    return this.http.post(this.snmpDestinationUrl, attr).toPromise();
  }

  public editSnmpDestination(snmpDestinationId: number, attr: object): Promise<any>{
    return this.http.put(`${this.snmpDestinationUrl}/${snmpDestinationId}`, attr).toPromise();
  }

  public deleteSnmpDestination(snmpDestinationId: number): Promise<any>{
    return this.http.delete(`${this.snmpDestinationUrl}/${snmpDestinationId}`).toPromise();
  }
}
